import React, { useEffect, useState } from "react";
import { Contact, Imgs, works } from "../types/types";
import {
  Container,
  FirstContainer,
  FooterContainer,
  Image,
  PrincipalContainer,
  SecondContainer,
  SelectWorks,
} from "./style";
import profiles3 from "../assets/banner/profiles.png";
import { Sliderbar } from "../components/Slider/Slider";
import { Slideshow } from "../containers/Slideshow/Slideshow";
import SiteArea from "../components/SiteArea/SiteArea";
import { getData, querySnapshot } from "../helpers/loadData";

export const Containers = () => {
  const [value, setValue] = useState(works[0]);
  useEffect(() => {});
  const event = (item) => {
    setValue(item);
  };
  return (
    <SecondContainer>
      <div>
        <p className="title_works">Where I have worked</p>
        <div className="container_works">
          <div className="menu_works">
            {works.map((item) => (
              <SelectWorks
                status={value.id === item.id}
                onClick={() => event(item)}
              >
                <p>{item.title}</p>
              </SelectWorks>
            ))}
          </div>
          <div>
            <h1>{value.title}</h1>
            {value.details.map((item) => (
              <li>{item.details}</li>
            ))}
          </div>
        </div>
      </div>
    </SecondContainer>
  );
};

export const ContainerSecond = () => {
  const [value, setValue] = useState(works[0]);
  useEffect(() => {});
  return (
    <FirstContainer>
      <div className="details">
        <div>
          <div className="details_title">
            <p>Hi</p>
            <p>I'm Bryan</p>
            <p> Backend Developer</p>
          </div>
          <p className="decription_title">
            I am Bryan from Ecuador. I am backend
            developer with 2 years experiencies. I have a passion for databases,
            docker, microservicies
          </p>
          <small> Themes : Nodejs - Reactjs </small>
          <div className="contact_title">
            {Contact.map((item) => (
              <img src={item.img} onClick={() => { window.location.href = item.url}}/>
            ))}
          </div>
        </div>
      </div>
      <div className="images">
        <img src={profiles3} />
      </div>
    </FirstContainer>
  );
};

const arrayComponents = [
  {
    id: 2,
    name: ContainerSecond,
  },
  {
    id: 1,
    name: Containers,
  },
];

export const RouterPrincipal = () => {
  const [projects, setprojects] = useState([]);
  
  useEffect(() => {
    querySnapshot("backend").then((results) => setprojects(results));
    querySnapshot("frontend").then((results) => {
      for (let index = 0; index < results.length; index++) {
        setprojects((old) => [...old, results[index]])
      }
    });
  }, []);
  return (
    <Container>
      <Sliderbar arrayComponents={arrayComponents} />
      <PrincipalContainer>
        <div>
          <h1>Knowledge</h1>
          <hr />
          <li>Nodejs</li>
          <li>React</li>
          <li>Postgresql</li>
        </div>
        <Image>
          <Slideshow />
        </Image>
      </PrincipalContainer>
      <FooterContainer>
        <SiteArea data={projects} />
      </FooterContainer>
    </Container>
  );
};
